import { GetDirectionsButton } from './GetDirectionsButton';
import styles from './LinkElement.module.css';
import { PinLink } from './PinLink';
import { MenuItemLink } from './MenuItemLink';

export const LinkElement = ({
  url,
  children,
  onCloseChat,
}: {
  url: string;
  children: React.ReactNode;
  onCloseChat: () => void;
}) => {
  try {
    const urlObj = new URL(url, window.location.origin);

    // Handle button actions
    if (urlObj.pathname === '/button') {
      const action = urlObj.searchParams.get('action');
      const pinKey = urlObj.searchParams.get('pinKey');

      if (action === 'getDirections' && pinKey) {
        return (
          <GetDirectionsButton pinKey={pinKey} onCloseChat={onCloseChat}>
            {children}
          </GetDirectionsButton>
        );
      }
    }

    if (urlObj.searchParams.has('menu_item')) {
      // This is a restaurant menu item link
      const menuItemKey = urlObj.searchParams.get('menu_item');
      const pinKey = urlObj.searchParams.get('pin');
      return (
        <MenuItemLink menuItemKey={menuItemKey} pinKey={pinKey} onCloseChat={onCloseChat}>
          {children}
        </MenuItemLink>
      );
    }

    // If url contains a pin query parameter, render as a special pin link
    if (urlObj.searchParams.has('pin')) {
      const pinKey = urlObj.searchParams.get('pin') ?? '';

      return (
        <PinLink pinKey={pinKey} onCloseChat={onCloseChat}>
          {children}
        </PinLink>
      );
    }

    return (
      <a className={styles.link} target="_blank" rel="noopener noreferrer" href={url}>
        {children}
      </a>
    );
  } catch (e) {
    // If URL parsing fails, render as regular link
    return (
      <a className={styles.link} target="_blank" rel="noopener noreferrer" href={url}>
        {children}
      </a>
    );
  }
};
